import type { FaqItem } from '../types/artTherapy'

/** Preguntas frecuentes de Baby Shower Dulce Recuerdo. */
export const babyShowerFaq: FaqItem[] = [
  {
    question: '¿Qué voy a recibir con mi compra?',
    answer:
      'Vas a recibir Baby Shower Dulce Recuerdo con 30 juegos imprimibles y, de regalo, cuatro bonos: 50 juegos y dinámicas en movimiento, la Guía de la organizadora, Tres planes de juegos de 60, 90 y 120 minutos y el Checklist de preparación e impresión. Todo en formato digital, para que puedas preparar las actividades para tu celebración.',
  },
  {
    question: '¿Los juegos vienen listos para imprimir?',
    answer:
      '¡Sí! Los 30 juegos principales están preparados en formato PDF, con instrucciones y hojas para las actividades. Solo tenés que elegir cuáles usar e imprimir las páginas necesarias.',
  },
  {
    question: '¿Incluye juegos para nena y nene?',
    answer:
      '¡Sí! Con una sola compra recibís las dos versiones del material: rosa y celeste. No necesitás elegir una ni pagar por separado.',
  },
  {
    question: '¿Las 50 dinámicas también necesitan imprimirse?',
    answer:
      'No todas. Son juegos y actividades grupales que podés organizar siguiendo las instrucciones. Algunas pueden requerir materiales sencillos o preparación previa.',
  },
  {
    question: '¿Necesito contratar a alguien para dirigir los juegos?',
    answer:
      'No. El material incluye instrucciones para que puedas preparar y coordinar las actividades vos misma o con ayuda de alguien de la familia.',
  },
  {
    question: '¿Voy a recibir algo físico en mi casa?',
    answer:
      'No. Es un producto 100% digital. Recibís archivos descargables, no una caja ni juegos impresos enviados por correo.',
  },
  {
    // IMPORTANTE: verificar que coincida con el sistema de entrega real antes de publicar.
    question: '¿Cómo recibo el material después de pagar?',
    answer:
      'Una vez confirmado el pago, vas a recibir las indicaciones para acceder y descargar tus archivos digitales.',
  },
  {
    question: '¿Qué pasa si el material no cumple mis expectativas?',
    answer:
      'Contás con una garantía comercial de satisfacción de 7 días desde la compra. Podés solicitar una devolución a través del canal de soporte informado al comprar. Esta garantía no limita los derechos que te correspondan por ley.',
  },
]
